import { Toaster } from "sonner";
import styled from "styled-components";
import { Icon } from "@/components/icon";
import { useSettings } from "@/store/settingStore";
import { themeVars } from "@/theme/theme.css";
import { rgbAlpha } from "@/utils/theme";

/**
 * https://sonner.emilkowal.ski/getting-started
 */
export default function Toast() {
	const { themeMode } = useSettings();

	return (
		<ToasterStyleWrapper>
			<Toaster
				position="top-right"
				theme={themeMode}
				closeButton
				toastOptions={{
					duration: 3000,
					style: {
						backgroundColor: themeVars.colors.background.paper,
					},
					classNames: {
						toast: "rounded-xl border bg-white shadow-[0_12px_32px_rgba(15,23,42,0.1)]",
						description: "text-xs text-[#6b7b93]",
						content: "flex-1 ml-6",
						icon: "flex items-center justify-center rounded-xl",
						success: "border-[#dbe7ff] bg-[#f8fbff]",
						error: "border-[#fecaca] bg-[#fff7f7]",
						warning: "bg-[#f8fbff]",
						info: "bg-[#f8fbff]",
						loading: "bg-[#f8fbff]",
					},
				}}
				icons={{
					success: (
						<div className="rounded-xl bg-[#eff6ff] p-2">
							<Icon icon="carbon:checkmark-filled" size={24} color={themeVars.colors.palette.primary.default} />
						</div>
					),
					error: (
						<div className="rounded-xl bg-[#fee2e2] p-2">
							<Icon icon="carbon:warning-hex-filled" size={24} color={themeVars.colors.palette.error.default} />
						</div>
					),
					warning: (
						<div className="rounded-xl bg-[#eff6ff] p-2">
							<Icon icon="carbon:warning-alt-filled" size={24} color={themeVars.colors.palette.primary.default} />
						</div>
					),
					info: (
						<div className="rounded-xl bg-[#eff6ff] p-2">
							<Icon icon="carbon:information-filled" size={24} color={themeVars.colors.palette.primary.default} />
						</div>
					),
					loading: (
						<div className="rounded-xl bg-[#eff6ff] p-2 text-[#2563eb]">
							<Icon icon="svg-spinners:6-dots-scale-middle" size={24} speed={3} />
						</div>
					),
				}}
				expand
			/>
		</ToasterStyleWrapper>
	);
}

const ToasterStyleWrapper = styled.div`
  [data-sonner-toast] {
    font-weight: 600;
    font-size: 14px;

    [data-cancel] {
      color: ${themeVars.colors.text.primary};
      background-color: transparent;
      &:hover {
        background-color: ${rgbAlpha(themeVars.colors.text.primaryChannel, 0.08)};
      }
    }

    /* Default */
    [data-action] {
      color: ${themeVars.colors.palette.primary.default};
      background-color: transparent;
      &:hover {
        background-color: ${rgbAlpha(themeVars.colors.palette.primary.defaultChannel, 0.08)};
      }
    }

    /* Loading */
    &[data-type="loading"] [data-icon] .sonner-loader[data-visible="true"] {
      margin-left: 12px;
    }

    /* Close Button */
    [data-close-button] {
      position: absolute;
      top: 0;
      right: 0;
      left: auto;
      display: flex;
      opacity: 1;
      visibility: visible;
      border-width: 1px;
      border-style: solid;
      color: ${themeVars.colors.palette.primary.default};
      background-color: ${themeVars.colors.background.paper};
      border: 1px solid ${rgbAlpha(themeVars.colors.palette.primary.defaultChannel, 0.2)};
    }

    &[data-type="error"] [data-close-button] {
      color: ${themeVars.colors.palette.error.default};
      border: 1px solid ${rgbAlpha(themeVars.colors.palette.error.defaultChannel, 0.2)};
    }
  }
`;
